var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfos2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1 1.12001C17.12 1.80001 11.2 5.14001 14.9 7.38001C16.98 8.64001 21.52 2.94001 23.8 1.66001C25.74 0.580014 29.14 0.360014 30.86 4.12001C33.04 8.88002 31.14 21.26 23.28 26.24C15.34 31.24 5.33999 28.7 1.87999 20.92C-2.14001 11.86 8.11999 -1.25999 15.1 1.12001ZM17.52 14.02C18.98 17.3 26.92 13.02 25.1 8.42001C23.92 5.44001 16.14 10.92 17.52 14.02Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfos2);
export default __webpack_public_path__ + "static/media/infos (2).15ed387b905a6ec9a31fd764455500da.svg";
export { ForwardRef as ReactComponent };